import type { AppleSignInResponse } from '@/core/data/auth/apple/apple.d';
import { ExternalLoader } from '@/core/helpers/external-loader';
import type { AuthScreenMethod } from '@/views/composables/auth/useAuth.interface';

let appleAuthInitialized = false;

const initApple = (clientId: string, redirectUri: string, cb: (loaded: boolean) => void): void => {
  if (!window.AppleID) {
    new ExternalLoader(['https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'], () => {
      window.AppleID?.auth.init({
        clientId,
        scope: 'name email',
        redirectURI: redirectUri,
        usePopup: true,
      });
      appleAuthInitialized = true;
      cb(true);
    });
  } else if (appleAuthInitialized) {
    cb(true);
  }
};

const appleSignIn = async (method: AuthScreenMethod): Promise<AppleSignInResponse | null> => {
  try {
    method.isLoading = true;
    const response = await window.AppleID?.auth.signIn();
    method.isLoading = false;
    return response || null;
  } catch {
    method.isLoading = false;
    return null;
  }
};

export default () => {
  return { initApple, appleSignIn };
};
